import {
  createProration,
  CreateProrationReturn,
  deleteProration,
  DeleteProrationReturn,
  updateProration,
  UpdateProrationParams,
  UpdateProrationReturn,
} from 'graphql/prorations/mutations';

import { createMutationHook } from 'hooks/factories/createMutationHook';

export const useCreateProration = createMutationHook<CreateProrationReturn>(createProration);
export const useUpdateProration = createMutationHook<UpdateProrationReturn, UpdateProrationParams>(
  updateProration
);
export const useDeleteProration = createMutationHook<DeleteProrationReturn>(deleteProration);
